import React, { useRef } from 'react';

import './ObvTileChart.scss';
import { XAxisContextProvider } from 'utils/components/TimeSeriesChart/XAxisContext';
import { scaleLinear } from 'd3-scale';
import { styleConstants as tileStyleConstants } from 'widgets/tiles/components/styles/variables.module.constants';
import { TileTimeSeriesChart } from 'widgets/tiles/components/tile/TileTimeSeriesChart';
import { ObvTileDataStateTimeSeriesItem } from 'widgets/obvTile/store/stream/ObvTileStreamState';
import { extentLinear } from '@d3fc/d3fc-extent';
import { ObvTileData } from 'widgets/obvTile/obvTileData';
import { obvTilesSeries } from 'widgets/obvTile/components/chart/series/obvTileSeries';
import { ObvTileChartValue } from 'widgets/obvTile/components/chart/ObvTileChartValue';

export interface ObvTileChartProps {
    chartKey: string;
    data: ObvTileData;
}

export function ObvTileChart(props: ObvTileChartProps) {
    const { data, chartKey } = props;
    const { timeSeries, startTime, endTime, breaksInTrading } = data;

    const height =
        tileStyleConstants.tileHeight -
        tileStyleConstants.tileWidgetToolbarHeight -
        tileStyleConstants.tileWidgetToolbarMarginTop;

    const yExtent = extentLinear()
        .accessors([(a: ObvTileDataStateTimeSeriesItem) => a.obv])
        .pad([0.1, 0.1]);
    const yScaleRef = useRef(scaleLinear());
    const yDomain = yExtent(timeSeries);
    yScaleRef.current.domain(yDomain);

    return (
        <div className="ObvTileChart">
            {startTime && endTime && (
                <XAxisContextProvider
                    timeSeriesChartWidth={tileStyleConstants.tileWidth}
                    startTime={startTime}
                    endTime={endTime}
                    breaks={breaksInTrading}
                    rangeLabels={[]}
                    timeLineLabels={[]}
                >
                    <ObvTileChartValue chartData={data} chartKey={chartKey} />
                    <TileTimeSeriesChart
                        id={`ObvTileTimeSeriesChart-${chartKey}`}
                        height={height}
                        data={timeSeries}
                        series={obvTilesSeries}
                        displayXAxis={true}
                        yScale={yScaleRef.current}
                        yTicks={0}
                    />
                </XAxisContextProvider>
            )}
        </div>
    );
}
